export default { 
  SET_STATUS_CARTOLA: (state, val) => state.cartola_manutencao = val
}